import styled from 'styled-components';
import ReactPannellum from "react-pannellum";
import StacInterface from "utils/StacInterface";
import React, { useEffect, useState } from 'react';
import ChevronUpIcon from 'mdi-react/ChevronUpIcon';
import ChevronDownIcon from 'mdi-react/ChevronDownIcon';
import ChevronLeftIcon from 'mdi-react/ChevronLeftIcon';
import ChevronRightIcon from 'mdi-react/ChevronRightIcon';

const Wrapper = styled.div`
  float: bottom;
  width: 100%;
  height: calc(100vh - 50px);
  padding: 5px;
  background: rgb(35, 35, 35);

  background: ${({ theme }) => theme.backgroundColor.locationModal.modal};
  color: ${({ theme }) => theme.textColor.secondary};
  border-radius: ${({ theme }) => theme.borderRadius.default};
`;

const StreetviewControllerContainer = styled.div`
  position: absolute;
  bottom: 10%;
  left: calc(50% - 100px);
  transform: perspective(250px) rotateX(60deg);
  width: 200px; 
  height: 200px;
`;

const LoadingDiv = styled.div`
    position: absolute;
    top: 50%;
    right: 50%;
    color: white;
    border: 10px solid #f3f3f3;
    border-top: 10px solid #3498db;
    border-radius: 50%;
    height: 100px;
    width: 100px;
    animation: spin 2s linear infinite;
`;

const StreetviewViewer = (props) => {
    const [asset, setAsset] = useState();
    const [loading, setLoading] = useState(true);
    const [panoramaViewer, setPanoramaViewer] = useState();
    const [panoramaLoaded, setPanoramaLoaded] = useState();
    const [panoramaViewerYaw, setPanoramaViewerYaw] = useState();
    const [upLink, setUpLink] = useState();
    const [backLink, setBackLink] = useState();
    const [leftLink, setLeftLink] = useState();
    const [rightLink, setRightLink] = useState();

    const getStreetviewImages = () => {
        setLoading(true);
        StacInterface.instance.getStreetviewImage(asset.layer_name, asset.uuid, 4000).then((response) => {
            let image = URL.createObjectURL(response.data);
            StacInterface.instance.getStreetviewLinks(asset.uuid).then((response) => {
                let links = response.data.links;
                if (panoramaViewer === undefined) {
                    setPanoramaViewer(<ReactPannellum
                        style={{ 'height': '100%', width: '100%', dynamic: true }}
                        id='pano'
                        sceneId={asset.uuid}
                        imageSource={image}
                        onPanoramaLoaded={() => setPanoramaLoaded(true)}
                        config={{ autoRotate: 0, autoLoad: true, compass: true, northOffset: asset.view_azimuth_deg }} />);
                } else {
                    let currentConfig = panoramaViewer.type.getConfig();
                    if (!(asset.uuid in currentConfig.scenes)) {
                        panoramaViewer.type.addScene(asset.uuid,
                            { imageSource: image, autoRotate: 0, autoLoad: true, compass: true, northOffset: asset.view_azimuth_deg },
                            (() => {
                                panoramaViewer.type.loadScene(asset.uuid);
                                panoramaViewer.type.setPitch(currentConfig.pitch, false);
                                panoramaViewer.type.setYaw(currentConfig.yaw, false);
                            }));
                    } else {
                        panoramaViewer.type.loadScene(asset.uuid);
                        panoramaViewer.type.setPitch(currentConfig.pitch, false);
                        panoramaViewer.type.setYaw(currentConfig.yaw, false);
                    }
                };
                
                links.forEach(link => {
                    let link_angle = link['angle'];

                    if (link_angle >= 315 || link_angle <= 45) {
                        setUpLink(link);
                    } else if (link_angle > 45 && link_angle <= 135) {
                        setRightLink(link)
                    } else if (link_angle > 135 && link_angle <= 225) {
                        setBackLink(link);
                    } else if (link_angle > 225 && link_angle <= 315) {
                        setLeftLink(link);
                    }
                });
                
                setLoading(false);
            });
        });
    }

    const handleStreetviewController = (link) => {
        props.setSelectedStreetview(link)
    }

    const handleViewChange = () => {
        setPanoramaViewerYaw(panoramaViewer.type.getYaw());
    };

    useEffect(() => {
        if (panoramaViewer === undefined || panoramaViewer.type.getViewer() === null) return;
        
        panoramaViewer.type.getViewer().on('mouseup', handleViewChange);
    }, [panoramaLoaded]);

    useEffect(() => {
        if (asset === undefined) return;

        getStreetviewImages();
    }, [asset]);

    useEffect(() => {
        if (props.selectedStreetview === undefined) return;

        if (asset !== props.selectedStreetview) {
            setAsset(props.selectedStreetview);
            setUpLink();
            setBackLink();
            setLeftLink();
            setRightLink();
        }
    }, [props.selectedStreetview]);

    return (
        <>
            <Wrapper id='panorama'>
                <div style={{ height: '100%' }}>
                    {panoramaViewer}
                    <StreetviewControllerContainer style={{transform: `perspective(250px) rotateX(60deg) rotate(${-panoramaViewerYaw}deg)`}} >
                        <button disabled={upLink === undefined} onClick={() => handleStreetviewController(upLink)}
                                style={{ position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)', background: 'none', border: 'none', cursor: upLink === undefined ? 'auto' : 'pointer', padding: 0, color: upLink === undefined ? 'grey' : 'yellow' }}>
                            <ChevronUpIcon size='10rem'/>
                        </button>
                        <button disabled={rightLink === undefined} onClick={() => handleStreetviewController(rightLink)}
                                style={{ position: 'absolute', right: 0, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: rightLink === undefined ? 'auto' : 'pointer', padding: 0, color: rightLink === undefined ? 'grey' : 'yellow' }} >
                            <ChevronRightIcon size='10rem'/>
                        </button>
                        <button disabled={backLink === undefined} onClick={() => handleStreetviewController(backLink)}
                                style={{ position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', background: 'none', border: 'none', cursor: backLink === undefined ? 'auto' : 'pointer', padding: 0, color: backLink === undefined ? 'grey' : 'yellow' }}>
                            <ChevronDownIcon size='10rem'/>
                        </button>
                        <button disabled={leftLink === undefined} onClick={() => handleStreetviewController(leftLink)}
                                style={{ position: 'absolute', left: 0, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: leftLink === undefined ? 'auto' : 'pointer', padding: 0, color: leftLink === undefined ? 'grey' : 'yellow' }}>
                            <ChevronLeftIcon size='10rem'/>
                        </button>
                    </StreetviewControllerContainer>
                    {loading && <LoadingDiv />}
                </div>
            </Wrapper>
        </>
    );
}

export default StreetviewViewer;